import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PathDefinitionsList from './PathDefinitionsList';
import PathDefinitionForm from './PathDefinitionForm';
import PathTestingTool from './PathTestingTool';
import PathDefinitionDetail from './PathDefinitionDetail';

import { AuthStdFooter } from "../../utils/auth-std-footer";
/**
 * PathRegistryManager component that serves as the container for all path registry management UI
 * This component handles routing between different path registry management views
 * @returns {JSX.Element} PathRegistryManager component
 */
const PathRegistryManager = () => {
  return (
    <Routes>
      {/* List view - default route */}
      <Route index element={<PathDefinitionsList />} />

      {/* Create new path definition */}
      <Route path="create" element={<PathDefinitionForm />} />

      {/* View path definition details */}
      <Route path=":name/view" element={<PathDefinitionDetail />} />

      {/* Edit path definition */}
      <Route path=":name/edit" element={<PathDefinitionForm />} />

      {/* Test path resolution */}
      <Route path="test" element={<PathTestingTool />} />

      {/* Redirect any other paths to the list view */}
      <Route path="*" element={<Navigate to="/admin/path-registry" replace />} />
    </Routes>
  );
};

export default PathRegistryManager;
